export enum SystemMode {
  firstread = "firstread",
  secondread = "secondread"
}

export const productName = {
  [SystemMode.firstread]: "First Read",
  [SystemMode.secondread]: "Second Read",
};
